import React from 'react'
import { connect } from 'react-redux'
import { setTab } from '../actions/appSettings'
import { ContentSwitcher, Switch } from '@wfp/ui'
import Draft from '../components/Draft'
import Table from '../components/Table'
import Page404 from '../components/404'

import { Disclaimer } from '../components/Disclaimer'
import { narrativeFetchRequested, setNarrative } from '../actions/narrative'
import ConfirmationModal from '../components/ConfirmationModal'

class Section extends React.Component {
  componentDidMount() {
    this.props.narrativeFetchRequested(this.props.match.params.id)
    this.setState({ loading: true })

    // Draft cannot mount within jsdom, as it makes browser function calls jsdom
    // doesn't support, eg, document.implementation.createHTMLDocument
    if (process.env.NODE_ENV === 'test') this.props.setTab('table')
    else this.props.setTab('text_box1')
  }

  logError = error => {
    if (error.response) {
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
      console.log(error.response.data.detail)
    } else {
      console.log(error)
    }
  }

  changeTab = event => {
    this.props.setTab(event.name)
  }

  render() {
    return (
      <div className='section-wrapper'>
        {!this.props.narrativeLoading && this.props.narrative && (
          <div>
            <div className='section-header'>
              <div>
                <h2 className='wfp--story__sub-title'>
                  {this.props.narrative.country_name} ({this.props.narrative.csp_country_key}) -{' '}
                  {this.props.narrative.year}
                  {this.props.narrative.status_label !== 'Draft'
                    ? ` - v. ${this.props.narrative.revision}.${this.props.narrative.revision_decimal_part}`
                    : ''}
                  &nbsp;
                  <span className='wfp--markup'>({this.props.narrative.state_title})</span>
                </h2>
              </div>
              <p className='wfp--markup'>
                Last updated by: {this.props.narrative.last_edited_by} on&nbsp;
                {this.props.narrative.updated_display}
              </p>
            </div>

            <Disclaimer />

            <ContentSwitcher onChange={this.changeTab}>
              <Switch name='text_box1' text='Transfer Modalities Narrative' />
              <Switch name='table' text='Table of Prioritized Activities' />
              <Switch name='text_box2' text='Prioritization Plan Narrative' />
            </ContentSwitcher>
            <div>
              {this.props.currentTab === 'text_box1' && <Draft />}
              {this.props.currentTab === 'table' && <Table />}
              {this.props.currentTab === 'text_box2' && <Draft />}
            </div>
          </div>
        )}
        {!this.props.narrative && !this.props.narrativeLoading && <Page404 />}
        <ConfirmationModal history={this.props.history} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentTab: state.appSettings.currentTab,
    userInfo: state.appSettings.userInfo,
    narrative: state.narrative.narrative,
    narrativeLoading: state.narrative.narrativeLoading,
  }
}

const mapDispatchToProps = {
  setNarrative,
  setTab,
  narrativeFetchRequested,
}

Section = connect(
  mapStateToProps,
  mapDispatchToProps
)(Section)

export default Section
